/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState, Suspense } from 'react';
import { Formik, ErrorMessage } from 'formik';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Box,
  CircularProgress,
  Grid,
  Card,
  CardMedia,
  // CardActionArea,
  CardContent,
  CardHeader,
  CardActions,
  TextField,
  // IconButton,
  Typography,
  FormHelperText,
  Stack,
  MenuItem,
  Avatar
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ImageUploading from 'react-images-uploading';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { ValidateOffice } from '../../../assets/validation';
import SettingAction from '../../../store/actions/SettingAction';
import globalAction from '../../../store/actions/GlobalAction';
import Loader from '../../../utils/errorPages/Loader';

function OfficeAddressEdit() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageLoader, setImageLoader] = React.useState(true);
  const [dataItem, setDataItem] = useState('');
  const [images, setImages] = React.useState([]);
  const { officeItemData, isLoading } = useSelector((state) => state.setting);
  const { statusData } = useSelector((state) => state.global);

  const { REACT_APP_API_URL } = process.env;

  const { code } = useParams();
  const maxNumber = 1;
  const onChange = (imageList, addUpdateIndex) => {
    console.log(addUpdateIndex, 'addUpdateIndex');
    setImages(imageList);
    // if(imageList.length > 0) {
    // setImageError("");
    // }
  };
  const onErrorChange = (errors, files) => {
    console.log(files, 'files');
    if (errors) {
      // setImages([]);
    }
  };

  useEffect(() => {
    dispatch(globalAction.getClientStatus());
    dispatch(SettingAction.getOfficeItem(code));
  }, [dispatch, code]);

  useEffect(() => {
    if (officeItemData && officeItemData !== undefined) {
      setDataItem(officeItemData);
    }
  }, [officeItemData]);

  useEffect(() => {
    setImageLoader(true);
    if (dataItem && dataItem !== undefined && dataItem !== '') {
      if (dataItem.logo && dataItem.logo !== undefined) {
        const arrValue = [];
        const arrObject = {
          path: dataItem.logo
        };
        arrValue.push(arrObject);
        setImages(arrValue);
      }
    }
    const timeoutId = setTimeout(() => {
      setImageLoader(false);
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [dataItem]);

  const getDirtyValues = (values, initialObject) => {
    const data = { ...values };
    const keyValues = Object.keys(data);

    const dirtyValues = keyValues.filter((keyValue) => data[keyValue] !== initialObject[keyValue]);

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete data[key];
    });
    return data;
  };
  const initialValues = {
    address_type: dataItem?.address_type ?? '',
    short_code: dataItem?.short_code ?? '',
    full_address: dataItem?.full_address ?? '',
    status: dataItem?.status ?? '',
    logo: []
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      {isLoading ? <Loader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/settings/bank">
            Office Address
          </Typography>
          <Typography component="h2" variant="h2">
            / Edit
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={ValidateOffice}
        enableReinitialize
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const updateValues = getDirtyValues(values, initialValues);
          const newValues = { ...updateValues };
          if (values.logo) {
            const newData = images.map((item) => item.file);
            if (newData.length > 0) {
              newValues.logo = newData;
            } else {
              delete newValues.logo;
            }
          }
          dispatch(SettingAction.updateOffice(code, newValues, setErrors, setSubmitting, navigate));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          handleReset,
          handleSubmit,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader title="Address Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={2}>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="address_type"
                          name="address_type"
                          label="Address Type"
                          variant="outlined"
                          value={values.address_type}
                          margin="normal"
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                            handleBlur(e);
                          }}
                          error={touched.address_type && Boolean(errors.address_type)}
                          helperText={touched.address_type && errors.address_type}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="short_code"
                          name="short_code"
                          label="Short Code"
                          variant="outlined"
                          value={values.short_code}
                          margin="normal"
                          inputProps={{
                            maxLength: 3
                          }}
                          onChange={(e) => {
                            let val = e.target.value.toUpperCase();
                            val = val.replace(/[^A-Z]/g, '');
                            setFieldValue('short_code', val);
                          }}
                          onBlur={(e) => {
                            const val = (e.target.value || '').toUpperCase().trim();
                            setFieldValue(e.target.name, val);
                            handleBlur(e);
                          }}
                          error={touched.short_code && Boolean(errors.short_code)}
                          helperText={touched.short_code && errors.short_code}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <ImageUploading
                          value={images}
                          onChange={onChange}
                          onError={onErrorChange}
                          maxFileSize={5242880}
                          maxNumber={maxNumber}
                          dataURLKey="data_url"
                          acceptType={['jpg', 'bmp', 'png']}
                        >
                          {({
                            imageList,
                            onImageUpload,
                            onImageUpdate,
                            // onImageRemove,
                            // isDragging,
                            dragProps,
                            errors
                          }) => (
                            <div className="upload__image-wrapper">
                              {images && images.length > 0 ? (
                                imageList.map((image, index) => {
                                  return (
                                    <Card
                                      sx={{
                                        height: '100%',
                                        width: '100%',
                                        border: '1px dashed rgba(20,20,20,0.75)',
                                        minHeight: '100px',
                                        maxHeight: '100px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer'
                                      }}
                                      key={index}
                                    >
                                      <Suspense fallback={<div>Loading...</div>}>
                                        {imageLoader ? (
                                          <CircularProgress size={20} />
                                        ) : (
                                          <CardMedia
                                            component="img"
                                            height="100"
                                            image={
                                              image.path
                                                ? `${REACT_APP_API_URL}/${image.path}`
                                                : image.data_url
                                            }
                                            alt="green iguana"
                                            onClick={() => onImageUpdate(index)}
                                          />
                                        )}
                                      </Suspense>
                                    </Card>
                                  );
                                })
                              ) : (
                                <Card
                                  sx={{
                                    height: '100%',
                                    width: '100%',
                                    border: '1px dashed rgba(20,20,20,0.75)',
                                    minHeight: '100px',
                                    maxHeight: '100px',
                                    // display: 'flex',
                                    // justifyContent: 'center',
                                    // alignItems: 'center',
                                    cursor: 'pointer'
                                  }}
                                  elevation={0}
                                >
                                  <CardContent sx={{ p: '20 !important', textAlign: 'center' }}>
                                    <Box
                                      sx={{ textAlign: 'center' }}
                                      onClick={onImageUpload}
                                      {...dragProps}
                                    >
                                      <Avatar sx={{ m: '0 auto', bgcolor: 'primary.main' }}>
                                        <FileUploadIcon />
                                      </Avatar>
                                      <FormHelperText
                                        sx={{ color: 'primary.main', textAlign: 'center' }}
                                      >
                                        Upload Image
                                      </FormHelperText>
                                    </Box>
                                  </CardContent>
                                </Card>
                              )}
                              {errors ? (
                                <FormHelperText error>
                                  {errors.acceptType && (
                                    <span>Selected file type is not allow</span>
                                  )}
                                  {errors.maxFileSize && <span>Image size cannot exceed 5 MB</span>}
                                  {errors.resolution && (
                                    <span>Selected file is not matching desired resolution</span>
                                  )}
                                </FormHelperText>
                              ) : (
                                ''
                              )}
                              <FormHelperText error>
                                <ErrorMessage name="logo" component="span" />
                              </FormHelperText>
                              {/* <Stack
                                className="upload__helpText"
                                direction="row"
                                spacing={2}
                                justifyContent="space-between"
                                alignItems="center">
                                <Typography variant="body1" component="p">
                                  File Size: Max 5 Mb
                                </Typography>
                                <Typography variant="body1" component="p">
                                  File Resolution: above <b>600 x 600</b> or <b>1:1</b> aspect ratio
                                </Typography>
                                <Typography variant="body1" component="p">
                                  File Format: .jpeg .jpg .png .bmp\
                                </Typography>
                              </Stack> */}
                            </div>
                          )}
                        </ImageUploading>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={2}>
                      <Grid item md={5} lg={5} xl={4}>
                        <TextField
                          fullWidth
                          id="full_address"
                          name="full_address"
                          label="Full Address"
                          variant="outlined"
                          multiline
                          rows={3}
                          margin="none"
                          onChange={handleChange}
                          value={values.full_address}
                          onBlur={(e) => {
                            handleBlur(e);
                            // const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            // setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.full_address && Boolean(errors.full_address)}
                          helperText={touched.full_address && errors.full_address}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={2}>
                      <Grid item md={2} lg={2} xl={2}>
                        <TextField
                          id="status"
                          fullWidth
                          label="Status"
                          name="status"
                          margin="normal"
                          select
                          value={values.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.status && touched.status}
                          helperText={errors.status && touched.status && errors.status}
                          required={false}
                          InputLabelProps={{ required: true }}
                        >
                          {statusData &&
                            statusData.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.status}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="submit"
                      className="save__btn"
                      variant="contained"
                      color="secondary"
                      // fullWidth
                      disabled={isSubmitting}
                      size="medium"
                    >
                      {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate('/settings');
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="info"
                      size="medium"
                      onClick={() => {
                        handleReset();
                        setImages([]);
                      }}
                    >
                      Clear
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
export default OfficeAddressEdit;
